export const CUT_DURATIONS = [0, 30, 60] as const;
